import styled from 'styled-components/macro'
import { useEffect, useState } from 'react'
import { useDebounce } from 'use-debounce'
import { FilterStore } from 'components/Filters/FilterStore'
import { useSearchWithSortReset } from 'hooks/useSearchWithSortReset'
import { PiMagnifyingGlass } from 'react-icons/pi'

export function TableSearch({
  searchPlaceholder,
  filterStore,
  className,
  tableKey,
  onFocus,
  onBlur,
}: {
  searchPlaceholder: string
  filterStore: FilterStore
  className?: string
  /** Optional: If provided, automatically clears sorting when search is applied */
  tableKey?: string
  onFocus?: () => void
  onBlur?: () => void
}) {
  const { search: searchFilter, setSearch } = filterStore()
  const search = searchFilter?.['search'] ?? { value: '', label: 'Search' }

  // Ensures sorting is cleared when search is applied
  useSearchWithSortReset(filterStore, tableKey)

  const [internalSearch, setInternalSearch] = useState(search)
  const [debouncedSearch] = useDebounce(internalSearch, 500)

  useEffect(() => {
    if (internalSearch === search) return
    setSearch('search', internalSearch.value, 'Search')
  }, [debouncedSearch])

  function onChange(e: any) {
    setInternalSearch({ value: e.target.value as string, label: 'Search' })
  }

  return (
    <div style={{ position: 'relative' }} className={className}>
      <IconContainer>
        <PiMagnifyingGlass />
      </IconContainer>
      <Input
        type="text"
        value={internalSearch.value}
        onChange={onChange}
        placeholder={searchPlaceholder}
        className="form-control"
        style={{ width: '100%' }}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </div>
  )
}

export const IconContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  align-items: center;
  background: transparent;
  padding-left: 10px;
  font-size: 18px;
`

export const Input = styled.input`
  display: flex;
  align-items: center;
  padding: 8px 14px;
  justify-content: space-between;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  gap: 10px;
  width: 320px;
  padding-left: 30px;
  height: 34px;
`
